import React from "react";
import PropTypes from "prop-types";
import buildAssetsUrl from "../../../../util/strings/buildAssetsUrl";

export const VehicleImage = ({ type }) => {
  const style = {
    height: "100%",
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const vehicleType = type.substring(12);

  return (
    <div style={style}>
      <img
        alt={vehicleType}
        src={buildAssetsUrl(`${vehicleType}.png`)}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          boxShadow: "inset 0px 0px 6px 6px rgba(255,255,255,1)",
        }}
      />
    </div>
  );
};

VehicleImage.propTypes = {
  type: PropTypes.string.isRequired,
};
